/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsBaseForAzure extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsBaseForAzure");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsBaseForAzure.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsBaseForAzure>): ServiceAccountEphemeralCredentialsBaseForAzure {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsBaseForAzure(), model);
        ServiceAccountEphemeralCredentialsBaseForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsBaseForAzure>): ServiceAccountEphemeralCredentialsBaseForAzure {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsBaseForAzure.newInstance(<ServiceAccountEphemeralCredentialsBaseForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsBaseForAzure) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsBaseForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsBaseForAzure): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsBaseForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
